import React from "react";
import { twMerge } from "tailwind-merge";

export const Avatar = ({
  alt,
  className,
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img
    className={twMerge("object-cover object-top", className)}
    alt={alt}
    {...props}
  />
);
